import { dateWordShort } from "../../../helper/helper";
import { Pencil, Warning } from "../../../assets/icons";
import { useState, useEffect } from "react";
import UseContext from "../../../hooks/useContext";
import useSlideOver from "../../SlideOver/useSlideOver";
import Tooltip from "../../tooltips/Tooltips";
import { useLocation } from "react-router-dom";
import TableCell from "./TableCell";
import TableRow from "./TableRow";
import { SECTOR_CONFIG } from "../../../pages/pages/qualification/qualification";

const TbodyQualification = ({ champsBody }) => {
    const { setObjID } = UseContext();
    const { toggleSlideOver } = useSlideOver();
    const location = useLocation();
    const [selectedId, setSelectedId] = useState(null);

    const editQualification = (idQualification) => {
        setSelectedId(idQualification);
        setObjID(idQualification);
        toggleSlideOver('qualification');
    };

    useEffect(() => {
        const id = new URLSearchParams(location.search).get('id');
        if (id) setSelectedId(id);
    }, [location.search]);

    return (
        <>
            {champsBody?.map((item) => {
                const sector = SECTOR_CONFIG[item.type] || SECTOR_CONFIG.other;

                return (
                    <TableRow
                        key={item._id}
                        itemId={item._id}
                        selectedId={selectedId}
                        onClick={editQualification}
                    >
                        <TableCell position="first" columnIndex={0} className="text-gray-900">
                            <div className="flex gap-2 items-center">
                                <span>{item.name}</span>
                                {item.isActive === false && (
                                    <span className="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset bg-red-50 text-red-600 ring-red-500/10">
                                        Désactivé
                                    </span>
                                )}
                                {!item.idBestt && (
                                    <Tooltip text="La mission n'a pas été référencée sur BeSTT" placement="right">
                                        <Warning wh={17} color="#EF4444" />
                                    </Tooltip>
                                )}
                            </div>
                        </TableCell>
                        <TableCell columnIndex={1} className="text-gray-900">
                            <span className={`inline-flex items-center rounded-md px-2 py-1 text-sm ring-1 ring-inset ${sector.className}`}>
                                {sector.label}
                            </span>
                        </TableCell>
                        <TableCell columnIndex={2} className="text-gray-500">
                            {item.createdAt ? dateWordShort(item.createdAt) : 'N/A'}
                        </TableCell>
                        <TableCell
                            position="last"
                            hasButton
                            buttonOnClick={(e) => {
                                e.stopPropagation();
                                editQualification(item._id);
                            }}
                            buttonContent={<Pencil wh={18} color="#111827" />}
                        />
                    </TableRow>
                );
            })}
        </>
    );
};

export default TbodyQualification;